module.exports = __webpack_public_path__ + "img/chinesecompany51.a3e5e3a2.png";